import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const courses = [
  { name: 'HTML', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg' },
  { name: 'Python', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg' },
  { name: 'JavaScript', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg' },
  { name: 'Kotlin', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/kotlin/kotlin-original.svg' },
  { name: 'Java', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg' },
  { name: 'C++', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg' },
  { name: 'C#', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg' },
  { name: 'SQL', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original.svg' },
  { name: 'React', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg' },
  { name: 'TypeScript', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg' },
  { name: 'Swift', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/swift/swift-original.svg' },
  { name: 'Go', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg' },
  { name: 'Rust', icon: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/rust/rust-original.svg' },
];

function LandingPage({ onStart, darkMode, onNavigate }) {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 300;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="landing-page" style={{ backgroundColor: darkMode ? '#131313' : 'transparent', color: darkMode ? '#fff' : 'inherit', position: 'relative' }}>
      <div className="floating-shapes">
        <span className="shape shape-1">{"{ }"}</span>
        <span className="shape shape-2">{"</>"}</span>
        <span className="shape shape-3">{";"}</span>
        <span className="shape shape-4">{"()"}</span>
        <span className="shape shape-5">{"#"}</span>
      </div>
      <header style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '70px',
        backgroundColor: darkMode ? '#131313' : '#fff',
        borderBottom: darkMode ? '2px solid #333' : '2px solid #e5e5e5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 10%', // Sorgt für seitlichen Abstand wie im Bild
        zIndex: 100
      }}>
        <h1 className="duocode-logo" style={{ margin: 0, fontSize: '1.8rem' }}>duocode</h1>
        <button 
          className="header-start-button" 
          onClick={() => { if (navigator.vibrate) navigator.vibrate(10); onStart(); }}
          style={{
            backgroundColor: '#179CF0',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            padding: '10px 25px',
            fontWeight: '800',
            fontSize: '0.9rem',
            cursor: 'pointer',
            boxShadow: '0 4px 0 #148ac2',
            textTransform: 'uppercase',
            transition: 'transform 0.1s'
          }}
        >
          ANFANGEN
        </button>
      </header>
      <main className="landing-main">
        <div className="landing-content">
            <div className="landing-hero-icon" style={{ fontSize: '100px', marginBottom: '20px' }}>🐬</div>
            <h1>Lerne Coden. <br/> Kostenlos & spielerisch.</h1>
            <button className="landing-button" onClick={() => { if (navigator.vibrate) navigator.vibrate(10); onStart(); }}>
                JETZT LOSLEGEN
            </button>
            <div className="landing-features">
              <div className="feature-item">
                <span>🎮</span>
                <p>Spielerisch</p>
              </div>
              <div className="feature-item">
                <span>🧠</span>
                <p>Effektiv</p>
              </div>
              <div className="feature-item">
                <span>💸</span>
                <p>Kostenlos</p>
              </div>
            </div>
        </div>
      </main>

      <div style={{ position: 'absolute', bottom: '90px', width: '100%', textAlign: 'center', fontSize: '0.85rem', zIndex: 10 }}>
        <a href="/impressum" onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('Impressum'); }} style={{ color: darkMode ? '#888' : '#777', textDecoration: 'none', marginRight: '20px', fontWeight: 'bold' }}>Impressum</a>
        <a href="/datenschutz" onClick={(e) => { e.preventDefault(); onNavigate && onNavigate('Datenschutz'); }} style={{ color: darkMode ? '#888' : '#777', textDecoration: 'none', fontWeight: 'bold' }}>Datenschutz</a>
      </div>

      <footer className="course-footer-bar" style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '80px',
        backgroundColor: darkMode ? '#131313' : '#fff',
        borderTop: darkMode ? '2px solid #333' : '2px solid #e5e5e5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0',
        zIndex: 20
      }}>
        <style>{`.no-scrollbar::-webkit-scrollbar { display: none; }`}</style>
        <div style={{
          width: '50%',
          minWidth: '320px', // Mindestbreite, damit es auf kleinen Bildschirmen bedienbar bleibt
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <button onClick={() => scroll('left')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#afafaf', display: 'flex', alignItems: 'center' }}>
            <ChevronLeft size={24} strokeWidth={3} />
          </button>
          
          <div ref={scrollRef} className="no-scrollbar" style={{ 
            flex: 1, 
            display: 'flex', 
            overflowX: 'auto', 
            gap: '40px', 
            padding: '0 20px',
            scrollBehavior: 'smooth',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            alignItems: 'center'
          }}>
            {courses.map((course, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '12px', flexShrink: 0 }}>
              <img src={course.icon} alt={course.name} style={{ width: '30px', height: '30px' }} />
              <span style={{ fontSize: '0.9rem', fontWeight: '900', color: darkMode ? '#aaa' : '#777', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                  {course.name}
                </span>
              </div>
            ))}
          </div>

          <button onClick={() => scroll('right')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#afafaf', display: 'flex', alignItems: 'center' }}>
            <ChevronRight size={24} strokeWidth={3} />
          </button>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;